import { RouteItem } from '@eastcoal/router/types/route'

export const userCenterRoute: RouteItem = {
  title: '个人中心',
  path: '/userCenter',
  hideInMenu: true,
  Component: () => import('./index')
}
